import { FC, ReactNode } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import Logo from 'builder/components/Logo'
import Icon from 'builder/components/Icon'
import Steps from 'builder/components/Steps'
import { SignUpCopyright } from 'builder/components/SignUpCopyright'
import { STEPS } from '../SignUpStepManager'
import { CloseButton, Container, Main, Navbar, StepsWrapper } from './styles'

type LayoutProps = {
  steps: string[]
  regionPrefix: string
  currentStepName: keyof typeof STEPS
  currentStepNumber: number
  children: ReactNode
  isStepperDisabled?: boolean
  isCopyrightDisabled?: boolean
}

const Layout: FC<LayoutProps> = ({
  children,
  steps,
  regionPrefix,
  currentStepName,
  currentStepNumber,
  isStepperDisabled = false,
  isCopyrightDisabled = false,
  ...rest
}) => {
  const homepageUrl = `/${regionPrefix}`

  const close = () => {
    trackInternalEvent('click_exit_button', { label: 'funnel' })
  }

  let currentStep = currentStepName === STEPS.onePageSignUp ? 1 : currentStepNumber

  return (
    <Container withImage={currentStepName !== STEPS.templates} {...rest}>
      <Navbar>
        <a aria-label="Logo" href={homepageUrl}>
          <Logo />
        </a>

        {!isStepperDisabled && (
          <StepsWrapper>
            <Steps steps={steps} currentStep={currentStep} />
          </StepsWrapper>
        )}

        <CloseButton onClick={close} aria-label="Close" href={homepageUrl}>
          <Icon.CloseLarge />
        </CloseButton>
      </Navbar>
      <Main>{children}</Main>
      {!isCopyrightDisabled && <SignUpCopyright />}
    </Container>
  )
}

export default Layout
